const styles = theme => {
  return {
    container: {
      display: 'grid',
      width: '100vw',
      height: '100vh',
      gridGap: '1rem',
      gridTemplateColumns: 'auto',
      // gridTemplateRows: '12% auto 3em',
      backgroundImage: 'linear-gradient(135deg, white, #dedede)',
      justifyContent: 'center',
      //alignItems: 'center'
      alignItems: 'normal',
      paddingTop: '105px'
    },
    '@media screen and (max-width: 1080px)': {
      container: {
        display: 'grid',
        width: '100vw',
        height: '100vh',
        gridGap: '1rem',
        gridTemplateColumns: 'auto',
        gridTemplateRows: '80vh auto 3em',
        backgroundImage: 'linear-gradient(135deg, white, #dedede)',
        justifyContent: 'center',
        overflowY: 'auto',
        // alignItems: 'center',
        alignItems: 'normal',
        paddingTop: '105px'
      }
    }
  };
};

export default styles;
